import dayjs from 'dayjs';
import formatDateToISO8601 from './formatDateToISO8601';
import isDateToday from './isDateToday';
import { useApplicationStore } from '@data';

export default function getAvailabilityRangeFromDate(date: string): {
  fromDateTime: string;
  toDateTime: string;
} {
  const { flags } = useApplicationStore.getState();
  let fromDateTime: Date | undefined;
  let toDateTime: Date | undefined;

  const dayjsDate = dayjs(date);

  if (isDateToday(dayjsDate)) {
    const currentTime = dayjs().format('HH:mm:ss');

    fromDateTime = dayjs(`${date} ${currentTime}`)
      .add(flags.appointmentBufferMinutes, 'minutes')
      .toDate();
    toDateTime = dayjs(fromDateTime).endOf('day').toDate();
  } else {
    fromDateTime = dayjsDate.startOf('day').toDate();
    toDateTime = dayjs(fromDateTime).endOf('day').toDate();
  }

  return {
    fromDateTime: formatDateToISO8601(fromDateTime),
    toDateTime: formatDateToISO8601(toDateTime),
  };
}
